module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"attendees":"attendees","present":"Present","not_present":"Not present","none":"None"},"hu":{"attendees":"résztvevők","present":"Jelen","not_present":"Nincs jelen","none":"Senki"}}')
  delete Component.options._Ctor
}
